import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { I18nModule } from '@spartacus/core'
import { GenericLinkModule, IconModule } from '@spartacus/storefront'
import { UserProfileModule } from '@spartacus/user'
import { EbFormModule } from '../../form/eb-form.module'
import { EbCommonFormFieldDataPolicyComponent } from './components/common-form-field-data-policy/eb-common-form-field-data-policy.component'
import { EbCommonFormLoginHintComponent } from './components/common-form-login-hint/eb-common-form-login-hint.component'
import { EbCommonFormRequiredHintComponent } from './components/common-form-required-hint/eb-common-form-required-hint.component'
import { CUSTOMER_INFO_NORMALIZER } from './converters/eb-common-converters'
import { EbCustomerInfoNormalizer } from './converters/eb-customer-info.normalizer'
import { EbCommonFormAdapter } from './services/connectors/eb-common-form.adapter'
import { EbCommonFormConfigService } from './services/facades/eb-common-form-config.service'

@NgModule({
  imports: [
    EbFormModule,
    ReactiveFormsModule,
    CommonModule,
    IconModule,
    I18nModule,
    UserProfileModule,
    GenericLinkModule
  ],
  exports: [
    EbCommonFormRequiredHintComponent,
    EbCommonFormLoginHintComponent,
    EbCommonFormFieldDataPolicyComponent
  ],
  declarations: [
    EbCommonFormRequiredHintComponent,
    EbCommonFormLoginHintComponent,
    EbCommonFormFieldDataPolicyComponent
  ],
  providers: [
    EbCommonFormConfigService,
    EbCommonFormAdapter,
    {
      provide: CUSTOMER_INFO_NORMALIZER,
      useClass: EbCustomerInfoNormalizer,
      multi: true
    }
  ]
})
export class EbCommonFormModule {}
